import {PartialTenantCustomizations} from "src/tenantCustomizations/TenantCustomizations.ts";
import {
	getInventoryLevelEventQuantitySpcSamplingMethod,
	getInventoryLevelEventTotalWeightSpcSamplingMethod,
} from "src/components/views/erp/spcSamplingMethods/inventoryLevelEventSpcSamplingMethods.tsx";
import { defaultSpcSamplingMethods } from "src/tenantCustomizations/defaultTenantCustomizations.ts";

export const necoCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			reclamationsEnabled: true,
			configuratorEnabled: true,
			defaultCustomerType: "COMPANY",
			customerOrderLineImportMethods: ["STANDARD_TABULAR"],
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
		workspacesEnabled: true,
	},
	spcSamplingMethods: () => [
		...defaultSpcSamplingMethods,
		getInventoryLevelEventQuantitySpcSamplingMethod(),
		getInventoryLevelEventTotalWeightSpcSamplingMethod(),
	],
};
